import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isNil, map } from 'lodash';
import cx from 'classnames';
import { ReactComponent as TrashIcon } from './assets/trash.svg';
import { ReactComponent as CheckIcon } from './assets/check.svg';
import { ReactComponent as StarIcon } from './assets/star-outline.svg';

import styles from './BankCard.module.scss';
import { BankCardIcon } from './BankCardIcon';
import config from 'config';

class BankCard extends Component {
  onClick = (e) => {
    this.props.onClick(e);
  };
  onClickDelete = (e) => {
    e.stopPropagation();
    this.props.onDelete(e);
  };

  renderMaskedPan = () => {
    const {
      cardDetails: { maskedPan },
    } = this.props;
    const formatted = maskedPan ? `${maskedPan.slice(0, 4)} •••• •••• ${maskedPan.slice(-4)}` : '';
    return map(formatted.split(' '), (path, index) => <div key={index}>{path}</div>);
  };

  renderCardNoSelected = () => {
    const { selected, onClick, isPayment } = this.props;
    return (
      <div
        className={cx(styles.BankCard, styles.NewCard, { [styles.selected]: selected })}
        onClick={onClick}
      >
        <div className={styles.controlIcons}>
          <div className={cx(styles.BankCard__check, { [styles.invisible]: !isPayment })}>
            <CheckIcon className={styles.check_icon} />
          </div>
        </div>

        <div className={styles.NewCard__text}>
          <div className={styles.PlusElement} />
          Новая карта
        </div>
      </div>
    );
  };

  render() {
    const { selected, onClick, cardDetails, isPayment } = this.props;
    if (!config.isInspectorArm && isNil(cardDetails.id)) {
      return this.renderCardNoSelected();
    }
    if (config.isInspectorArm && isNil(cardDetails.id)) {
      return null;
    }
    return (
      <div
        className={cx(styles.BankCard, {
          [styles.selected]: selected,
          [styles.inactive]: !isPayment,
        })}
        onClick={onClick}
      >
        <div className={styles.controlIcons}>
          <div className={cx(styles.BankCard__check, { [styles.invisible]: !isPayment })}>
            {isPayment ? (
              <CheckIcon className={styles.check_icon} />
            ) : (
              <StarIcon className={styles.check_icon} />
            )}
          </div>
          {!config.isInspectorArm && (
            <div className={styles.BankCard__delete} onClick={this.onClickDelete}>
              <TrashIcon className={styles.delete_icon} />
            </div>
          )}
        </div>
        <div className={styles.BankCard__number}>{this.renderMaskedPan()}</div>
        <div className={styles.BankCard__issueDate}>{`•• / ••`}</div>
        <div className={styles.BankCard__bankIcon}>
          <BankCardIcon number={cardDetails.maskedPan} />
        </div>
      </div>
    );
  }
}

BankCard.propTypes = {
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
  selected: PropTypes.bool,
  isPayment: PropTypes.bool,
  cardDetails: PropTypes.shape({
    maskedPan: PropTypes.string,
    id: PropTypes.string,
    recurrent: PropTypes.string,
    isDefault: PropTypes.bool,
  }),
};

export default BankCard;
